(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Web3Connect", [], factory);
	else if(typeof exports === 'object')
		exports["Web3Connect"] = factory();
	else
		root["Web3Connect"] = factory();
})(this, function() {
return 